global.antRouter = ''//全局的路由
global.IS_IDS4 = false // 默认false，表示使用JWT模式，如果true，表示使用ids4